import React, { createContext, useState } from "react"

export const ActiveBlockContext = createContext({})

export const ActiveBlockProvider = ({ children }) => {
  const [activeBlockId, setActiveBlockId] = useState(null)
  const [override, setOverride] = useState(null)
  const [overrideProps, setOverrideProps] = useState({})

  return (
    <ActiveBlockContext.Provider
      value={{
        activeBlockId,
        setActiveBlockId,
        override,
        setOverride,
        overrideProps,
        setOverrideProps
      }}
    >
      {children}
    </ActiveBlockContext.Provider>
  )
}
